module.exports = __webpack_public_path__ + "img/SendReport.b84fa25f.svg";